import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addPortCallData,
  deleteDocuments,
  deletePortCallData,
  fetchPortCallingListData,
  updatePortCallData,
  getPortCallingList,
  addDocumentData,
} from "../../apis/portCall";

export const fetchPortCalls = createAsyncThunk(
  "portCalls/fetchPortCallingData",
  async (_, { rejectWithValue }) => {
    try {
      const portCalls = await fetchPortCallingListData();
      return portCalls;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },{
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.portCalls.isDataFetched; // Adjust path based on your state structure
    },
  }
);

export const getPortCallingListData = createAsyncThunk(
  "portCalls/getPortCalla",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getPortCallingList({
        param: { page: 0, pageSize: 25 },
      }); // Pass the required parameters
      return response;
    } catch (error: any) {
      console.log("Error in fetching portCallings:", error);
      return rejectWithValue(error?.message);
    }
  }
);

export const updatePortCall = createAsyncThunk(
  "portCalls/updatePortCall",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        portCallingsId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updatePortCallData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deletePortCall = createAsyncThunk(
  "portCalls/deletePortCall",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deletePortCallData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewPortCallData = createAsyncThunk(
  "portCalls/deletePortCallData",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addPortCallData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteDocumentData = createAsyncThunk(
  "portCalls/deleteDocuments",
  async (
    {
      id,
      portCallingsId,
    }: {
      id: string;
      portCallingsId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      await deleteDocuments(id);
      return {
        id,
        portCallingsId,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewDocumentData = createAsyncThunk(
  "portCalls/addNewDocumentData",
  async (
    {
      data,
      portCallingsId,
    }: {
      data: {
        [key: string]: any;
      };
      portCallingsId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addDocumentData(data, portCallingsId);
      return {
        portCallingsId,
        data: response,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
